import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import List from "./list";
import Edit from "./edit";

export default class Index extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/organizations" component={List}/>
                    <Route path="/organizations/create" component={Edit}/>
                    <Route path="/organizations/:id" component={Edit}/>
                </Switch>
        )
    }
}
